import { takeLatest, put, all, call } from 'redux-saga/effects';

import ENACHUmrnUplaodActionTypes from './nach-umrn-link.type';

import {
	fetchENACHApplicationDetails,
	fetchENACHPaymentUploadDetails,
	fetchENACHUmrnUploadDetails,
} from './nach-umrn-link.service';
import {
	fetchENACHExportDetailsFailure,
	fetchENACHExportDetailsResponseChanged,
	fetchENACHExportDetailsSuccess,
	fetchENACHPaymentUploadFailure,
	fetchENACHPaymentUploadResponseChanged,
	fetchENACHPaymentUploadSuccess,
	fetchENACHUMRNUploadFailure,
	fetchENACHUMRNUploadResponseChanged,
	fetchENACHUMRNUploadSuccess,
} from './nach-umrn-link.action';
import { encryptData } from '../../_common/enode-decode';

export function* getENACHApplicationDetails({ payload }: any) {
	try {
		const key = 'GetEnachApplicationDetailsListkey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			DisbursementDate: payload.DisbursementDate,
			BranchID: payload.BranchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchENACHApplicationDetails, encodeData);
		if (responseData.data.statusCode === '100') {
			yield put(fetchENACHExportDetailsFailure(responseData.data));
		} else {
			yield put(fetchENACHExportDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchENACHExportDetailsFailure(error));
	}
}

export function* resetFetchEnachDetailsResponse() {
	yield put(fetchENACHExportDetailsResponseChanged());
}

export function* onFetchENACHDetails() {
	yield takeLatest(
		ENACHUmrnUplaodActionTypes.FETCH_ENACH_EXPORT_DETAILS_START,
		getENACHApplicationDetails,
	);
}

export function* onFetchENACHDetailsResponseReset() {
	yield takeLatest(
		ENACHUmrnUplaodActionTypes.FETCH_ENACH_EXPORT_DETAILS_RESPONSE_RESET,
		resetFetchEnachDetailsResponse,
	);
}

export function* uploadEnachUmrnDetails({ payload }: any) {
	try {
		const key = 'UpdateEnachUmrnDetailsListkey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			UploadedBy: payload.userID,
			UploadArr: payload.UploadArr,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchENACHUmrnUploadDetails, encodeData);
		if (responseData.data.statusCode === '100') {
			yield put(fetchENACHUMRNUploadFailure(responseData.data));
		} else {
			yield put(fetchENACHUMRNUploadSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchENACHUMRNUploadFailure(error));
	}
}

export function* resetFetchEnachUmrnUploadResponse() {
	yield put(fetchENACHUMRNUploadResponseChanged());
}

export function* onUploadEnachUmrn() {
	yield takeLatest(
		ENACHUmrnUplaodActionTypes.FETCH_ENACH_UMRN_UPLOAD_START,
		uploadEnachUmrnDetails,
	);
}

export function* onUploadEnachUmrnResponseReset() {
	yield takeLatest(
		ENACHUmrnUplaodActionTypes.FETCH_ENACH_UMRN_UPLOAD_RESPONSE_RESET,
		resetFetchEnachUmrnUploadResponse,
	);
}

export function* uploadEnachPaymentDetails({ payload }: any) {
	try {
		const key = 'UpdateEnachPaymentDetailsListkey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			UploadedBy: payload.userID,
			UploadArr: payload.UploadArr,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchENACHPaymentUploadDetails, encodeData);
		if (responseData.data.statusCode === '100') {
			yield put(fetchENACHPaymentUploadFailure(responseData.data));
		} else {
			yield put(fetchENACHPaymentUploadSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchENACHPaymentUploadFailure(error));
	}
}

export function* resetFetchEnachPaymentUploadResponse() {
	yield put(fetchENACHPaymentUploadResponseChanged());
}

export function* onUploadEnachPayment() {
	yield takeLatest(
		ENACHUmrnUplaodActionTypes.FETCH_ENACH_PAYMENT_UPLOAD_START,
		uploadEnachPaymentDetails,
	);
}

export function* onUploadEnachPaymentResponseReset() {
	yield takeLatest(
		ENACHUmrnUplaodActionTypes.FETCH_ENACH_PAYMENT_UPLOAD_RESPONSE_RESET,
		resetFetchEnachPaymentUploadResponse,
	);
}

export function* enachUploadDetailsSaga() {
	yield all([
		call(onFetchENACHDetails),
		call(onFetchENACHDetailsResponseReset),
		call(onUploadEnachUmrn),
		call(onUploadEnachUmrnResponseReset),
		call(onUploadEnachPayment),
		call(onUploadEnachPaymentResponseReset),
	]);
}
